import { isBoolean } from 'lodash';
import { getFiltersDefinition } from './FiltersDefinition';

export const getRelevantFilters = filters => {
  const relevantFilters = [];
  filters.forEach(filter => {
    if (filter.value !== 'all' && filter.state)
      relevantFilters.push({
        group: filter.group,
        value: filter.value,
        state: filter.state,
      });
  });

  return relevantFilters;
};

export const getFiltersForRequest = filters => {
  const groupedFilters = {};
  getRelevantFilters(filters).forEach(filter => {
    const filteredProperty = getFiltersDefinition()[filter.group]?.propertyForApi || filter.group;
    if (!isBoolean(filter.state) && filter.state !== '') {
      groupedFilters[filteredProperty] = filter.state;
    } else {
      if (!{}.hasOwnProperty.call(groupedFilters, filteredProperty)) groupedFilters[filteredProperty] = filter.value;
      else groupedFilters[filteredProperty] = groupedFilters[filteredProperty].concat(',', filter.value);
    }
  });

  const ret = [];
  Object.entries(groupedFilters).forEach(([key, value]) => {
    ret.push(''.concat(key, ':', value));
  });

  return ret;
};

  // getRelevantFilters(filters).forEach(filter => {
  //   const filteredProperty = getFiltersDefinition()[filter.group]?.propertyForApi || filter.group;
  //   const filterState = moment.isMoment(filter.state) ? filter.state.format() : filter.state;
  //   if (!isBoolean(filterState) && filterState !== '') {
  //     groupedFilters[filteredProperty] = filterState;
  //   } else {
  //     if (!{}.hasOwnProperty.call(groupedFilters, filteredProperty)) groupedFilters[filteredProperty] = filter.value;
  //     else groupedFilters[filteredProperty] = groupedFilters[filteredProperty].concat(',', filter.value);
  //   }
  // });

export const urlInjected = search => {
  const urlParams = new URLSearchParams(search);
  const filtersSerialized = JSON.parse(urlParams.get('filters'));
  if (!filtersSerialized || filtersSerialized.length === 0) return false;
  return true;
};

export const getFilterValueFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const filtersSerialized = urlParams.get('filters');
  const filtersFromUrl = JSON.parse(filtersSerialized);
  const ret = [];
  filtersFromUrl?.forEach(f => {
    const [group, valuesString] = f.split(':');
    const values = valuesString.split(',');
    values.forEach(value => {
      const isNumber = isNaN(Number(value)) === false;
      ret.push({
        group,
        value: isNumber ? group : value,
        state: isNumber ? parseInt(value, 10) : true,
      });
    });
  });
  return ret;
};